import { style } from "@vanilla-extract/css";
import { vars } from "../../../../styles";

export const fixtureKOTime = style({
  display: "inline-block",
  padding: `${vars.space["2xs"]} ${vars.space.xs}`,
  color: vars.colors.onSurface,
  fontFamily: vars.fonts.bold,
  fontSize: vars.fontSizes.body.l,
});
